import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class WheelService {
  static endpoints = {
    points        : `${baseUrl}/spinning-wheel/points`,
    pointsPrizes  : `${baseUrl}/spinning-wheel/points/prizes`,
    pointsClaim   : `${baseUrl}/spinning-wheel/points/claim`,
    tokens        : `${baseUrl}/spinning-wheel/tokens`,
    tokensPrizes  : `${baseUrl}/spinning-wheel/tokens/prizes`,
    tokensClaims  : `${baseUrl}/spinning-wheel/tokens/today-claim`,
  };

  static wheelType = {
    TOKENS : 1,
    POINTS : 2
  };

  static getPointsPrize() {
    return axios.get(this.endpoints.points).then((response)=> response.data.prize);
  }

  static getPointsPrizes() {
    return axios.get(this.endpoints.pointsPrizes).then((response)=> response.data.prizes);
  }

  static getTokensPrizes() {
    return axios.get(this.endpoints.tokensPrizes).then((response)=> response.data.prizes);
  }

  static getTokensPrize() {
    return axios.get(this.endpoints.tokens).then((response)=> response.data.prize);
  }

  static hasTodayTokensClaims () {
    return axios.get(this.endpoints.tokensClaims).then((response)=> response.data.hasClaim);
  }

  static hasSpinningWheelPoints () {
    return axios.get(this.endpoints.pointsClaim).then((response)=> response.data.hasClaim);
  }
}